import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorPillComponent } from './vendor-pill.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { AddUsersDialogComponent } from '../../supplier/add-users-dialog/add-users-dialog.component';
import { UserManualDirective } from '../user-manual/user-manual.directive';

@NgModule({
  declarations: [VendorPillComponent, AddUsersDialogComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    UserManualDirective,
  ],
  exports: [VendorPillComponent, AddUsersDialogComponent],
})
export class VendorPillModule {}
